import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { ThirdAuthM8Component } from 'src/app/shared/components/third-auth-m8/third-auth-m8.component';
import { ThirdAuthUser, Web3WalletType } from 'src/app/shared/interfaces/auth.interface';
import { DialogType, LoginService } from '../login.service';
@Component({
  standalone: true,
  selector: 'third-party',
  templateUrl: './third-party.component.html',
  styleUrls: ['./third-party.component.scss'],
  imports: [CSIconButtonComponent, FormsModule, ThirdAuthM8Component],
})
export class ThirdPartyComponent {
  constructor(
    public dialogRef: MatDialogRef<ThirdPartyComponent>,
    public loginService: LoginService,
  ) {
    this.thirdPartyType$.subscribe(type => {
      const srcBase = '/assets/images/login-wallets/';
      switch (type) {
        case Web3WalletType.Coinbase:
          this.title = 'COINBASE';
          this.imgSrc = srcBase + 'coinbase.svg';
          this.text = 'Coinbase wallet';
          break;
        case Web3WalletType.MetaMask:
          this.title = 'METAMASK';
          this.imgSrc = srcBase + 'metamask.svg';
          this.text = 'MetaMask wallet';
          break;
        case Web3WalletType.TonConnect:
          this.title = 'TON';
          this.imgSrc = srcBase + 'tonconnect.svg';
          this.text = 'Ton wallet';
          break;
        case Web3WalletType.WalletConnect:
          this.title = 'WALLETCONNECT';
          this.imgSrc = srcBase + 'walletconnect.svg';
          this.text = 'WalletConnect wallet';
          break;
        case Web3WalletType.CoinbaseWallet:
          this.title = 'BASE';
          this.imgSrc = srcBase + 'coinbasewallet.svg';
          this.text = 'Base Wallet';
          break;
        default:
          break;
      }
    });
  }

  public title = '';

  public imgSrc = '';

  public thirdPartyType$ = this.loginService.thirdPartyType$;

  public text = '';

  clickAuthName(authName: ThirdAuthUser) {
    this.loginService.handleThirdPartyNotLogin(authName);
  }

  public back(): void {
    this.loginService.dialogType$.next(DialogType.LOGIN_REGISTER);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
